import styled from 'styled-components';
import { Modal, GlobalToken } from 'antd';

export const ModalContainer = styled(Modal)<{ theme: { token: GlobalToken } }>`
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  left: auto !important;
  bottom: auto !important;
  margin: 0 !important;
  max-width: 369px;
  transform: none !important;

  .ant-modal-content {
    background: ${({ theme: { token } }) => token.colorBgElevated};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    padding: 0;
    box-shadow: ${({ theme: { token } }) => token.boxShadowSecondary};
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    display: none;
  }

  .input-field {
    width: 50%;
    border: none;
    outline: none;
    background: ${({ theme: { token } }) => token.colorBgContainer};
    appearance: textfield;

    /* Hide spinner for Chrome, Safari, Edge */
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Hide spinner for Firefox */
    &[type='number'] {
      -moz-appearance: textfield;
    }
  }
`;

export const ModalHeader = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => `${token.paddingLG}px ${token.padding}px ${token.paddingSM}px`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  background: ${({ theme: { token } }) => token.colorBgElevated};
`;

export const ModalHeaderTitle = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextHeading};
  font-family: ${({ theme: { token } }) => token.fontFamily};
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  line-height: ${({ theme: { token } }) => token.lineHeightLG};
`;

export const ModalHeaderActions = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;

  .anticon {
    cursor: pointer;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px;
    border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme: { token } }) => token.colorBgTextHover};
      color: ${({ theme: { token } }) => token.colorText};
    }
  }
`;

export const ModalContent = styled.div<{ theme: { token: GlobalToken } }>`
  background: ${({ theme: { token } }) => token.colorBgElevated};
`;

export const ModalBody = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => `${token.paddingLG}px ${token.padding}px ${token.paddingSM}px`};
`;

export const ModalField = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ModalFieldLabel = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  display: flex;
  align-items: center;
  line-height: ${({ theme: { token } }) => token.lineHeightHeading1};
`;

export const ModalFieldValue = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  text-align: right;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
`;

export const ModalFieldHighlight = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  background: ${({ theme: { token } }) => token.colorPrimaryBg};
  padding: ${({ theme: { token } }) => `${token.paddingXS}px ${token.paddingSM}px`};
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  display: inline-block;
  width: fit-content;
  text-align: right;
`;

export const ModalActions = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => `${token.paddingSM}px ${token.padding}px ${token.paddingSM}px`};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme: { token } }) => token.paddingSM}px;
  border-top: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  background: ${({ theme: { token } }) => token.colorBgElevated};
`;

export const MinimizedContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: fixed;
  top: 20px;
  right: 20px;
  background: ${({ theme: { token } }) => token.colorBgElevated};
  border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  padding: ${({ theme: { token } }) => `${token.paddingSM}px ${token.padding}px`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme: { token } }) => token.marginSM}px;
  cursor: pointer;
  box-shadow: ${({ theme: { token } }) => token.boxShadowSecondary};
  z-index: 1000;
  min-width: 200px;

  &:hover {
    box-shadow: ${({ theme: { token } }) => token.boxShadow};
  }

  .anticon {
    cursor: pointer;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px;
    border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme: { token } }) => token.colorBgTextHover};
      color: ${({ theme: { token } }) => token.colorText};
    }
  }
`;
